﻿import { useEffect } from "react";
import {IMvvmContextState, MvvmContextState} from "./MvvmContextState";
import {MvvmValidation, Paths} from "./MvvmControlProps";

export function useRegisterValidation<T extends object, TValue>(context: IMvvmContextState<T>, property: Paths<T>, controlId: string, validation: MvvmValidation<TValue> | undefined): void {
	useEffect(() => {
		(context as MvvmContextState<T>).registerValidation(property, controlId, validation);
		return () => (context as MvvmContextState<T>).unregisterValidation(property)
	}, [context, property, controlId, validation?.required, validation?.validate]);
}
